export default "__VITE_ASSET__07eaf6fc__"